<template>
  <div>
    <label class="titleLabel">访问量类别占比</label>
    <hr class="titleHr">
    <div
      id="visitpercentChart"
      :style="{ width: '705.4px', height: '600px' }"
    ></div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useI18n } from "@/i18nPlugin";
import * as echarts from "echarts";
import { getVisitData } from "../../api/index";
var moment = require('moment')
export default defineComponent({
    props: {
        watchData: Object,
    },
    setup() {
        const i18n = useI18n();
        const token = localStorage.getItem("userToken");
        const getVisitChart = (n) => {
            if(n.tag == 'day') {
                getVisitData({
                    startTime: n.dayStart ? moment(n.dayStart).format("YYYY-MM-DD") : n.dayStart,
                    endTime: n.dayEnd ? moment(n.dayEnd).format("YYYY-MM-DD") : n.dayEnd
                },token).then(res => {
                    legendData.value = res.data.legendData
                    seriesData.value = res.data.seriesDatas
                    showCharts();
                    console.log(res.data)
                }).catch(error => {
                    console.log(error)
                });
            }else if(n.tag == 'month'){
                getVisitData({
                    startTime: n.monthStart ? moment(n.monthStart).format("YYYY-MM-DD") : n.monthStart,
                    endTime: n.monthEnd ? moment(n.monthEnd).format("YYYY-MM-DD") : n.monthEnd
                },token).then(res => {
                    legendData.value = res.data.legendData
                    seriesData.value = res.data.seriesDatas
                    showCharts();
                    console.log(res.data)
                }).catch(error => {
                    console.log(error)
                });
            }
        }
        const legendData = ref([])
        const seriesData = ref([])
        const showCharts = () => {
        let myChart = echarts.init(document.getElementById("visitpercentChart"));
        // 绘制图表
        myChart.setOption({
            tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b}: {c} ({d}%)",
            },
            legend: {
                top: '5%',
                data: legendData.value,
            },
            series: [
                {
                    name: "访问量",
                    type: "pie",
                    radius: ["35%", "45%"],
                    labelLine: {
                    length: 30,
                    },
                    label: {
                        formatter: "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                        backgroundColor: "#F6F8FC",
                        borderColor: "#8C8D8E",
                        borderWidth: 1,
                        borderRadius: 4,
                        rich: {
                            a: {
                                color: "#6E7079",
                                lineHeight: 22,
                                align: "center",
                            },
                            hr: {
                                borderColor: "#8C8D8E",
                                width: "100%",
                                borderWidth: 1,
                                height: 0,
                            },
                            b: {
                                color: "#4C5058",
                                fontSize: 14,
                                fontWeight: "bold",
                                lineHeight: 33,
                            },
                            per: {
                                color: "#fff",
                                backgroundColor: "#4C5058",
                                padding: [3, 4],
                                borderRadius: 4,
                            },
                        },
                    },
                    data: seriesData.value,
                },
            ],
        });
        window.onresize = function () {
                // 自适应大小
                myChart.resize();
        };
    };
    return {
        i18n,
        seriesData,
        legendData,
        showCharts,
        getVisitChart
    };
    },
    watch: {
        watchData: {
            handler(n, o) {
                this.getVisitChart(n);
                // console.log(n.tag)
                // console.log(n.monthStart)
                // console.log(n.monthEnd)
                // console.log(n.dayStart)
                // console.log(n.dayEnd)
            },
            deep: true, // 深度监听父组件传过来对象变化
        },
    }
});
</script>
    
<style scoped>
    .titleLabel {
      display: block;
      font-size: 16px;
      font-weight: bold;
      padding: 10px 0px 5px 20px;
    }
    .titleHr {
      border: 1px solid #e2e4e6;
    }
</style>